// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CarLogo_wrapper__Rs99i"};